import { useGetFitterQuery } from 'feature/user/redux/fitter.api'
import { LoaderInCentalPosition } from 'widget'
import styles from './LkmProductTypesList.module.scss'

export function LkmProductTypesList() {
  const { data, isLoading } = useGetFitterQuery()

  if (isLoading && !data) return <LoaderInCentalPosition />

  return (
    <div className={styles.productTypesList}>
      {data?.products.map(item => (
        <div key={item.code} className={styles.productTypesList__item}>
          {item.name}
        </div>
      ))}
    </div>
  )
}
